import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function About() {
  const teamMembers = [
    {
      name: "Ide Rosine Deumaga",
      role: "Fondatrice & Directrice Générale",
      description: "Une Nantaise qui porte l'ailleurs en elle, Rosine a créé Ideevents pour valoriser la richesse du continent africain et créer des ponts entre l'Afrique et l'Europe.",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/ba3bc1f5f29dc290e08e92e3c0317a5e.jpeg"
    }
  ];

  const partners = [
    { name: "Château des ducs de Bretagne", logo: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/0d9b3f98fa0cd7b9cda8cdf8eac38c39.png" },
    { name: "Musée d'arts de Nantes", logo: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/5a0deed7e0c99cac54daf46d41f60193.png" },
    { name: "Le Pavillon Afrique", logo: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/c5b22317855fc2545ae6966eb5f4e131.png" },
    { name: "Institut Français Cameroun", logo: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/ade8b66891d9d686199f1976ef4ae106.png" },
    { name: "Nantes Métropole", logo: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/e0bf79d6099b4e00cbd4167ef8ea3424.png" }
  ];

  const testimonials = [
    {
      quote: "J'ai eu l'occasion de travailler avec Ide Rosine Deumaga notamment sur l'organisation d'un défilé de mode africaine dans le cadre de la grande exposition L'abîme. Nantes dans la traite atlantique et l'esclavage colonial. 1707-1830. À cette occasion, j'ai pu apprécier à la fois sa force de conviction, sa détermination à mener à bien ses projets mais aussi ses talents d'organisation et d'animation d'équipe.",
      author: "Pierre-François Parodi",
      role: "Responsable de la programmation culturelle du Château des ducs de Bretagne musée d'histoire de Nantes"
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/ebb2ff55d6ef58387036a522060a295f.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            À propos d'<span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">Ideevents</span>
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Une agence engagée pour la valorisation de la culture africaine contemporaine et la création d'événements porteurs de sens
          </p>
        </div>
      </section>

      {/* Histoire et Mission */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-8">Notre histoire</h2>
              <div className="space-y-6 text-lg text-gray-600">
                <p>
                  Fondée en 2023 par <strong>Ide Rosine Deumaga</strong>, une Nantaise qui porte l'ailleurs en elle, <strong>Ideevents</strong> est née d'une vision claire : créer un pont entre l'Afrique et l'Europe à travers des événements culturels et économiques d'exception.
                </p>
                <p>
                  Forte d'une solide expérience dans l'événementiel associatif et animée par une profonde passion pour la culture africaine, Rosine Deumaga s'impose progressivement comme une actrice incontournable de la scène culturelle nantaise et régionale.
                </p>
                <p>
                  Aujourd'hui, entourée de ses différentes équipes, Ideevents conçoit, coordonne et met en scène plus d'<strong>une dizaine d'événements par an</strong>, touchant plus de <strong>50 000 personnes</strong> à travers des manifestations qui célèbrent la diversité, la créativité et l'innovation responsable.
                </p>
              </div>
            </div>
            <div className="h-96 bg-cover bg-center rounded-2xl shadow-xl" style={{
              backgroundImage: `url('https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/ba3bc1f5f29dc290e08e92e3c0317a5e.jpeg')`
            }}></div>
          </div>
        </div>
      </section>

      {/* Mission et Valeurs */}
      <section className="py-20 bg-gradient-to-b from-orange-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Notre mission & nos valeurs
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Nous œuvrons chaque jour pour valoriser la richesse culturelle africaine et créer des ponts interculturels
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mx-auto mb-6">
                <i className="ri-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Authenticité</h3>
              <p className="text-gray-600">
                Nous valorisons la culture africaine dans sa diversité et son authenticité, loin des clichés et stéréotypes.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mx-auto mb-6">
                <i className="ri-group-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Inclusivité</h3>
              <p className="text-gray-600">
                Nos événements sont ouverts à tous et célèbrent la diversité culturelle comme une richesse partagée.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mx-auto mb-6">
                <i className="ri-leaf-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Durabilité</h3>
              <p className="text-gray-600">
                Nous intégrons les enjeux environnementaux et sociaux dans tous nos projets pour un impact positif durable.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mx-auto mb-6">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Innovation</h3>
              <p className="text-gray-600">
                Nous créons des expériences uniques en alliant tradition et modernité, créativité et professionnalisme.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Équipe */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Notre équipe
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Des professionnels passionnés et engagés pour la réussite de vos événements
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-1 gap-12 justify-center">
            {teamMembers.map((member, index) => (
              <div key={index} className="text-center max-w-md mx-auto">
                <div className="h-80 bg-cover bg-center rounded-2xl shadow-xl mb-6" style={{
                  backgroundImage: `url('${member.image}')`
                }}></div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{member.name}</h3>
                <p className="text-orange-500 font-semibold mb-4">{member.role}</p>
                <p className="text-gray-600">{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Engagement */}
      <section className="py-20 bg-gradient-to-r from-orange-500 to-amber-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="text-white">
              <h2 className="text-4xl font-bold mb-8">Notre engagement</h2>
              <div className="space-y-6 text-lg">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold mb-2">Diversité culturelle</h3>
                    <p className="text-orange-100">
                      Nous mettons en lumière la richesse des 54 pays africains et de leurs diasporas, en valorisant leurs spécificités culturelles, artistiques et entrepreneuriales.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold mb-2">Inclusion sociale</h3>
                    <p className="text-orange-100">
                      Nos événements favorisent le dialogue interculturel et luttent contre les discriminations en créant des espaces de rencontre et d'échange.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold mb-2">Développement durable</h3>
                    <p className="text-orange-100">
                      Nous privilégions les circuits courts, les matériaux recyclables et soutenons l'économie circulaire africaine à travers nos événements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-96 bg-cover bg-center rounded-2xl shadow-xl" style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=diverse%20african%20community%20engagement%2C%20cultural%20inclusion%20celebration%2C%20sustainable%20development%20in%20africa%2C%20community%20empowerment%2C%20social%20impact%20initiatives%2C%20multicultural%20harmony%2C%20african%20diaspora%20unity&width=600&height=400&seq=engagement-ideevents&orientation=landscape')`
            }}></div>
          </div>
        </div>
      </section>

      {/* Témoignages */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Ils nous font confiance
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Découvrez les témoignages de nos partenaires institutionnels et clients
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="flex items-center justify-center w-12 h-12 bg-orange-100 rounded-full mb-6">
                  <i className="ri-double-quotes-l text-orange-500 text-xl"></i>
                </div>
                <p className="text-gray-600 mb-6 italic">"{testimonial.quote}"</p>
                <div>
                  <p className="font-bold text-gray-900">{testimonial.author}</p>
                  <p className="text-orange-500 text-sm">{testimonial.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partenaires */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Nos partenaires institutionnels
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Nous collaborons avec des institutions de référence pour porter nos projets
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8 items-center">
            {partners.map((partner, index) => (
              <div key={index} className="flex items-center justify-center p-6 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors duration-200 hover:shadow-lg">
                <img 
                  src={partner.logo} 
                  alt={`Logo ${partner.name}`}
                  title={partner.name}
                  className="max-h-24 w-auto object-contain transition-transform duration-200 hover:scale-105"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-r from-orange-500 to-amber-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Rejoignez l'aventure Ideevents
          </h2>
          <p className="text-xl text-orange-100 mb-8">
            Ensemble, créons des événements qui célèbrent la diversité et construisent des ponts entre les cultures
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="secondary" size="lg">
              <i className="ri-phone-line mr-2"></i>
              Nous contacter
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-orange-500">
              <i className="ri-team-line mr-2"></i>
              Rejoindre l'équipe
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
